module.exports = __webpack_public_path__ + "static/img/cop_sch_logo10.5bc0f557.png";